import { CompanyOpeningPhase } from '@/types'
import { CompanyOpeningStatus } from './company-opening-status'
import { CurrentStep } from './utils'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@mui/material'

type CompanyOpeningStatusDialogProps = DialogProps & {
  currentStep: CurrentStep
  phases: CompanyOpeningPhase[]
  onClose: () => void
}

export function CompanyOpeningStatusDialog({
  currentStep,
  phases,
  onClose,
  ...props
}: CompanyOpeningStatusDialogProps) {
  return (
    <Dialog {...props} onClose={onClose}>
      <DialogTitle>Status de abertura da PJ</DialogTitle>
      <DialogContent>
        <CompanyOpeningStatus currentStep={currentStep} phases={phases} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
